// extracted by mini-css-extract-plugin
export default {"container":"Page_container__g2VJi","content":"Page_content__wekN3","noMargin":"Page_noMargin__UJEct","pageButton":"Page_pageButton__2ym3G"};